import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../data/data.service';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class CartService {
  // private cartItems = new BehaviorSubject<any[]>([]);
  // private cartItemCount = new BehaviorSubject<number>(0);

  // cartItems$ = this.cartItems.asObservable();
  // cartItemCount$ = this.cartItemCount.asObservable();

  // constructor() { }

  // getCartItems(): any[] {
  //   return this.cartItems.value;
  // }

  // getCartItemCount(): number {
  //   return this.cartItemCount.value;
  // }

  // addToCart(item: any): void {
  //   const currentItems = this.cartItems.value;
  //   const existingItem = currentItems.find(cartItem => cartItem.id === item.id);
    
  //   if (existingItem) {
  //     existingItem.quantity += item.quantity;
  //   } else {
  //     currentItems.push({
  //       ...item,
  //       quantity: item.quantity
  //     });
  //   }
    
  //   this.cartItems.next([...currentItems]);
  //   this.updateCartItemCount();
  // }

  // removeFromCart(index: number): void {
  //   const currentItems = this.cartItems.value;
  //   currentItems.splice(index, 1);
  //   this.cartItems.next([...currentItems]);
  //   this.updateCartItemCount();
  // }

  // updateQuantity(index: number, quantity: number): void {
  //   if (quantity > 0) {
  //     const currentItems = this.cartItems.value;
  //     currentItems[index].quantity = quantity;
  //     this.cartItems.next([...currentItems]);
  //     this.updateCartItemCount();
  //   }
  // }

  // clearCart(): void {
  //   this.cartItems.next([]);
  //   this.cartItemCount.next(0);
  // }

  // private updateCartItemCount(): void {
  //   const totalItems = this.cartItems.value.reduce((total, item) => total + item.quantity, 0);
  //   this.cartItemCount.next(totalItems);
  // }

private cartItems = new BehaviorSubject<any[]>([]);
private cartItemCount = new BehaviorSubject<number>(0);

cartItems$ = this.cartItems.asObservable();
cartItemCount$ = this.cartItemCount.asObservable();
wishlist: any[] = [];

constructor(private data:DataService,private http:HttpClient) { 

  this.loadCart();
  this.loadWishlist();
}



/* GET ALL CART ITEMS */
getCartItems(): any[] {
  return this.cartItems.value;
}

/* GET UNIQUE PRODUCT COUNT */
getCartItemCount(): number {
  alert(this.cartItemCount.value);
  return this.cartItemCount.value;
}


loadCart(): void {

  const customerId = localStorage.getItem('customer_id');

  this.http.post<any>(
    this.data.base_url + 'get_cart_items/',
    {
      customer_id: customerId
    }
  ).subscribe(res => {

    if (res.status === 1) {

      this.cartItems.next(res.data);

      this.updateCartItemCount();
    }

  });
}


addToCart(product: any): void {

  const customerId = localStorage.getItem('customer_id');

  this.http.post<any>(
    this.data.base_url + 'add_to_cart/',
    {
      customer_id: customerId,
      product_id: product.id,
      quantity: product.quantity || 1
    }
  ).subscribe(res => {

    if (res.status === 1) {

      this.loadCart();
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: `Added to Cart`,
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          customClass: {
            popup: 'cart-toast',
            title: 'cart-toast-title'
          }
        });
    }

  });
}

updateQuantity(cart_item_id: any, quantity: number): void {
  console.log("item",cart_item_id);
  this.http.post<any>(
    this.data.base_url + 'update_cart_quantity/',
    {
      cart_item_id: cart_item_id,
      quantity: quantity
    }
  ).subscribe(() => {

    this.loadCart();

  });

}

removeFromCart(cart_item_id: any): void {

  this.http.post<any>(
    this.data.base_url + 'remove_cart_item/',
    {
      cart_item_id:cart_item_id
    }
  ).subscribe(() => {

    this.loadCart();

  });

}

private updateCartItemCount(): void {

  // const count = this.cartItems.value.reduce(
  //   (total: number, item: any) => total + item.quantity,
  //   0
  // );
const count = this.cartItems.value.length;

  this.cartItemCount.next(count);
}


clearCart(): void {
  const customerId = localStorage.getItem('customer_id');
  this.http.post<any>(
    this.data.base_url + 'clear_cart/',
    {
      customer_id: customerId
    }
  ).subscribe({
    next: (res) => {
      if (res.status === 1) {
        this.cartItems.next([]);
        this.cartItemCount.next(0);
      }
    },
    error: (err) => {
      console.error('Error clearing cart:', err);
    }
  });
}


// /* ADD TO CART */
// addToCart(item: any): void {

//   const currentItems = [...this.cartItems.value];

//   const existingItem = currentItems.find(
//     cartItem => cartItem.id === item.id
//   );

//   if (existingItem) {

//     /* MERGE QUANTITY */
//     existingItem.quantity += item.quantity;

//   } else {

//     currentItems.push({
//       ...item,
//       quantity: item.quantity || 1
//     });

//   }

//   this.cartItems.next(currentItems);

//   this.updateCartItemCount();
// }

/* REMOVE ITEM */
// removeFromCart(index: number): void {

//   const currentItems = [...this.cartItems.value];

//   currentItems.splice(index, 1);

//   this.cartItems.next(currentItems);

//   this.updateCartItemCount();
// }

/* UPDATE QUANTITY */
// updateQuantity(index: number, quantity: number): void {

//   if (quantity > 0) {

//     const currentItems = [...this.cartItems.value];

//     currentItems[index].quantity = quantity;

//     this.cartItems.next(currentItems);

//     this.updateCartItemCount();
//   }
// }

/* CLEAR CART */
// clearCart(): void {

//   this.cartItems.next([]);

//   this.cartItemCount.next(0);
// }

/* UPDATE UNIQUE PRODUCT COUNT */
// private updateCartItemCount(): void {

//   /* UNIQUE PRODUCTS COUNT */
//   const totalProducts = this.cartItems.value.length;

//   this.cartItemCount.next(totalProducts);
// }


 private wishlistCountSource = new BehaviorSubject<number>(0);

  wishlistCount$ = this.wishlistCountSource.asObservable();

  setCount(count: number): void {
    this.wishlistCountSource.next(count);
  }

  getCount(): number {
    return this.wishlistCountSource.value;
  }
  

  loadWishlist(): void {
        const customerId = localStorage.getItem('customer_id');
        this.http.post<any>( this.data.base_url+'get_wishlist/', {
            customer_id: customerId
        }).subscribe({
            next: (res) => {
                if (res.status === 1) {
                    this.wishlist = res.data.map((item: any) => ({
                        id: item.id,
                        title: item.product_name,
                        description: item.product_description,
                        price: item.mrp,
                        image: item.product_image,
                        stock: item.stock,
                        quantity: 1
                    }));

                     this.setCount(this.wishlist.length);
                }
            },
            error: (err) => console.error('Error fetching wishlist', err)
        });
    }

}
